import { createAction, props } from '@ngrx/store';
import { Redes } from 'src/app/metricas/metricas.model';

export const cargaRedes= createAction(
  '[REDES] Carga',
  props<{ redes: Redes[] }>()
  );
export const limpiaRedes = createAction('[REDES] Remueve');